import { safeExecute } from "@opendaw/lib-std";
import { Box, NoPointers, Field, Int32Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class AudioTimeStretchBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new AudioTimeStretchBox({
            uuid,
            graph,
            name: "AudioTimeStretchBox",
            pointerRules: {
                accepts: [Pointers.AudioPlayMode],
                mandatory: true,
                exclusive: false,
            },
        }), constructor);
    }
    static ClassName = "AudioTimeStretchBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitAudioTimeStretchBox, this);
    }
    get warpMarkers() {
        return this.getField(1);
    }
    get transientPlayMode() {
        return this.getField(2);
    }
    get playbackRate() {
        return this.getField(3);
    }
    initializeFields() {
        return {
            1: Field.hook({
                parent: this,
                fieldKey: 1,
                fieldName: "warpMarkers",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.WarpMarkers],
                    mandatory: true,
                    exclusive: false,
                },
            }),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "transientPlayMode",
                deprecated: false,
                pointerRules: NoPointers,
            }, "positive", "enum", 2),
            3: Float32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "playbackRate",
                deprecated: false,
                pointerRules: NoPointers,
            }, "positive", "ratio", 1),
        };
    }
}
